import * as React from 'react'
import type { SVGProps } from 'react'
function SvgGasteStadtGastepasse216135437136(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 283.1 233.6"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M111,48.1h61c1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5h-61c-1.9,0-3.5,1.6-3.5,3.5S109.1,48.1,111,48.1z" />
        <path d="M255.6,41.1h-17.7c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h17.7c11.3,0,20.5,9.2,20.5,20.5v137.5 c0,11.3-9.2,20.5-20.5,20.5H27.5c-11.3,0-20.5-9.2-20.5-20.5V68.6c0-11.3,9.2-20.5,20.5-20.5h17.7c1.9,0,3.5-1.6,3.5-3.5 s-1.6-3.5-3.5-3.5H27.5C12.3,41.1,0,53.4,0,68.6v137.5c0,15.2,12.3,27.5,27.5,27.5l228.1,0c15.2,0,27.5-12.3,27.5-27.5V68.6 C283.1,53.4,270.7,41.1,255.6,41.1z" />
        <path d="M200.5,69.2h8.8c6.6,0,12-5.4,12-12V12c0-6.6-5.4-12-12-12h-8.8c-6.6,0-12,5.4-12,12v45.2 C188.5,63.8,193.9,69.2,200.5,69.2z M195.5,57.2V12c0-2.8,2.2-5,5-5h8.8c2.8,0,5,2.2,5,5v45.2c0,2.8-2.2,5-5,5h-8.8 C197.8,62.2,195.5,59.9,195.5,57.2z" />
        <path d="M73.7,69.2h8.8c6.6,0,12-5.4,12-12V12c0-6.6-5.4-12-12-12h-8.8c-6.6,0-12,5.4-12,12v45.2C61.7,63.8,67.1,69.2,73.7,69.2z  M87.5,57.2c0,2.8-2.2,5-5,5h-8.8c-2.8,0-5-2.2-5-5V12c0-2.8,2.2-5,5-5h8.8c2.8,0,5,2.2,5,5V57.2z" />
        <path d="M81,135.9c11.2,0,20.4-9.1,20.4-20.4S92.2,95.1,81,95.1s-20.4,9.1-20.4,20.4S69.8,135.9,81,135.9z M67.6,115.5 c0-7.4,6-13.4,13.4-13.4s13.4,6,13.4,13.4c0,7.4-6,13.4-13.4,13.4S67.6,122.9,67.6,115.5z" />
        <path d="M45.3,179.5c1.9,0,3.5-1.6,3.5-3.5c0-11.9,14.5-21.5,32.2-21.5s32.2,9.6,32.2,21.5c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5 c0-15.7-17.6-28.5-39.2-28.5S41.8,160.3,41.8,176C41.8,177.9,43.3,179.5,45.3,179.5z" />
        <path d="M237.8,101h-73.6c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h73.6c1.9,0,3.5-1.6,3.5-3.5S239.7,101,237.8,101z" />
        <path d="M237.8,168.7h-73.6c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h73.6c1.9,0,3.5-1.6,3.5-3.5S239.7,168.7,237.8,168.7z" />
        <path d="M237.8,134.8h-73.6c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h73.6c1.9,0,3.5-1.6,3.5-3.5S239.7,134.8,237.8,134.8z" />
      </g>
    </svg>
  )
}
export default SvgGasteStadtGastepasse216135437136
